<template>
    <section class="admin-sidebar">
        <div class="d-flex align-items-center justify-content-between border-bottom w-100 p-3">
            <b-btn :to="{ name: 'Main' }"
                   class="btn-round-4"
                   variant="info"
                   size="sm"
            >
                🏡HOME
            </b-btn>
            <b-btn :to="{ path: '/project_code_list' }"
                   class="btn-round-4"
                   variant="warning"
                   size="sm"
            >
                🎨ADMIN
            </b-btn>
        </div>
        <div class="p-3">
            <div class="w-100 mb-3">
                반갑습니다🌷
            </div>
            <div
                class="d-flex align-items-center border border-color-gray-500 bgray-100 shadow-sm rounded-sm w-100 p-1">
                <div class="d-flex flex-grow-0 w-25 h-25">
                    <img class="rounded-circle w-100" src="@shared/assets/img/qesg_logo.png" alt="profile image"/>
                </div>
                <div class="d-flex flex-column justify-content-between flex-grow-1 h-100 px-1">
                    <p class="mb-1">{{ user_name }}</p>
                    <p class="small mb-0">{{ company_name }}</p>
                </div>
            </div>
        </div>
        <b-nav vertical class="w-100 admin-sidebar-links">
            <b-nav-item v-if="is_admin === 4" class="nav-parent-group">
                <span :class="['nav-parent', {'active': parentLinkActive.assessment }]"
                      @click="parentLinkCollapseState.assessment = !parentLinkCollapseState.assessment"
                >
                    평가관리
                </span>

                <b-collapse v-model="parentLinkCollapseState.assessment">
                    <b-nav vertical class="nav-child-group">
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingAssessment' }">
                            평가관리
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingProjectCode' }">
                            프로젝트 코드
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingProjectGroup' }">
                            평가 그룹
                        </b-nav-item>
                        <b-nav-item class="nav-sub-group nav-console-group">
                            <b-nav-item class="nav-child-link nav-console-parent"
                                        :class="{ 'children-expanded': parentLinkCollapseState.projectConsole }"
                                        :to="{ name: 'ManagingProjectConsole' }"
                            >
                                프로젝트 배정 콘솔
                            </b-nav-item>
                            <b-collapse v-model="parentLinkCollapseState.projectConsole">
                                <b-nav vertical class="nav-subchild-group nav-console-children">
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingCampaignConnectRule' }">
                                        캠페인 연결 규칙 (고급)
                                    </b-nav-item>
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingProjectSchema' }">
                                        프로젝트 스키마 (고급)
                                    </b-nav-item>
                                </b-nav>
                            </b-collapse>
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingVendorCode' }">
                            벤더코드 관리
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'CampaignRemap' }">
                            답변 보존 캠페인 재배정
                        </b-nav-item>
                    </b-nav>
                </b-collapse>
            </b-nav-item>
            <b-nav-item v-if="is_admin === 4" class="nav-parent-group">
                <span :class="['nav-parent', {'active': parentLinkActive.user }]"
                      @click="parentLinkCollapseState.user = !parentLinkCollapseState.user"
                >
                    사용자관리
                </span>

                <b-collapse v-model="parentLinkCollapseState.user">
                    <b-nav vertical class="nav-child-group">
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingClient' }"> 원청사</b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingParticipationCompany' }"> 일반기업
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'ManagingUser' }"> 사용자</b-nav-item>
                    </b-nav>
                </b-collapse>
            </b-nav-item>
            <b-nav-item v-if="is_admin >= 3" class="nav-parent-group">
                <span :class="['nav-parent', {'active': parentLinkActive.aiAssessment }]"
                      @click="parentLinkCollapseState.aiAssessment = !parentLinkCollapseState.aiAssessment"
                >
                    AI 기능 관리
                </span>

                <b-collapse v-model="parentLinkCollapseState.aiAssessment">
                    <b-nav vertical class="nav-child-group">
                        <b-nav-item class="nav-sub-group">
                            <span :class="['nav-sub-parent', {'active': parentLinkActive.aiSupplement, 'expanded': parentLinkCollapseState.aiSupplement }]"
                                  @click="parentLinkCollapseState.aiSupplement = !parentLinkCollapseState.aiSupplement"
                            >
                                AI 보완 검토
                            </span>
                            <b-collapse v-model="parentLinkCollapseState.aiSupplement">
                                <b-nav vertical class="nav-subchild-group">
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingSupplementReviewList' }">
                                        보완 검토
                                    </b-nav-item>
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingSupplementPrompt' }">
                                        보완 검토 프롬프트
                                    </b-nav-item>
                                </b-nav>
                            </b-collapse>
                        </b-nav-item>
                        <b-nav-item class="nav-sub-group">
                            <span :class="['nav-sub-parent', {'active': parentLinkActive.aiEval, 'expanded': parentLinkCollapseState.aiEval }]"
                                  @click="parentLinkCollapseState.aiEval = !parentLinkCollapseState.aiEval"
                            >
                                AI 평가
                            </span>
                            <b-collapse v-model="parentLinkCollapseState.aiEval">
                                <b-nav vertical class="nav-subchild-group">
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingAiAssessment' }">
                                        평가 관리
                                    </b-nav-item>
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingEvalProfiles' }">
                                        평가 프로파일
                                    </b-nav-item>
                                    <b-nav-item class="nav-child-link" :to="{ name: 'ManagingEvalPrompt' }">
                                        AI 판단 기준
                                    </b-nav-item>
                                </b-nav>
                            </b-collapse>
                        </b-nav-item>
                    </b-nav>
                </b-collapse>
            </b-nav-item>
            <b-nav-item v-if="is_admin === 4" class="nav-parent-group" :to="{ name: 'DownloadCenter' }">
                 <span :class="['nav-parent', {'active': parentLinkActive.downloadCenter }]"
                 >
                  다운로드 센터
                </span>
            </b-nav-item>
            <b-nav-item v-if="is_admin === 4" class="nav-parent-group">
                <span :class="['nav-parent', {'active': parentLinkActive.mail }]"
                      @click="parentLinkCollapseState.mail = !parentLinkCollapseState.mail"
                >
                    메일 관리
                </span>

                <b-collapse v-model="parentLinkCollapseState.mail">
                    <b-nav vertical class="nav-child-group">
                        <!-- router-link 활성은 경로 prefix 매칭이라 /mail/simulation 에서도 켜진다. 시뮬레이션일 때만 exact 로 끈다 (편집기에서는 유지). -->
                        <b-nav-item class="nav-child-link" :to="{ name: 'MailDashboard' }" :exact="$route.name === 'MailSimulation'">
                            템플릿
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'MailSimulation' }">
                            템플릿 시뮬레이션
                        </b-nav-item>
                        <!-- 스니펫 관리는 내부(개발자용)라 메뉴에서 숨김. 라우트(MailSnippet)는 유지되어 직접 URL 접근은 가능. -->
                        <b-nav-item v-if="is_admin === 4" class="nav-child-link" :to="{ name: 'ProjectBrandManagement' }">
                            브랜드(프로젝트)
                        </b-nav-item>
                    </b-nav>
                </b-collapse>
            </b-nav-item>
            <b-nav-item v-if="is_admin === 4" class="nav-parent-group">
                <span :class="['nav-parent', {'active': parentLinkActive.attachments }]"
                      @click="parentLinkCollapseState.attachments = !parentLinkCollapseState.attachments"
                >
                    첨부파일 관리
                </span>

                <b-collapse v-model="parentLinkCollapseState.attachments">
                    <b-nav vertical class="nav-child-group">
                        <b-nav-item class="nav-child-link" :to="{ name: 'CopyAttachments' }">
                            첨부파일 복사
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'DocumentFacts' }">
                            문서 사실 추출
                        </b-nav-item>
                        <b-nav-item class="nav-child-link" :to="{ name: 'DocumentFactBatches' }">
                            추출 배치 관리
                        </b-nav-item>
                    </b-nav>
                </b-collapse>
            </b-nav-item>
            <b-nav-item v-if="is_admin === 4" class="observability-menu-item" :to="{ name: 'ApiObservability' }">API 이용 현황</b-nav-item>
        </b-nav>
    </section>
</template>

<script>
import {mapState} from 'vuex';

// AI 기능 관리 하위 2단계 그룹의 라우트 매핑 (보완 검토 / 평가)
const AI_SUPPLEMENT_ROUTES = ['ManagingSupplementReviewList', 'ManagingSupplementReview', 'ManagingSupplementPrompt'];
const AI_EVAL_ROUTES = ['ManagingAiAssessment', 'ManagingEvalProfiles', 'ManagingEvalPrompt'];
const AI_ALL_ROUTES = [...AI_SUPPLEMENT_ROUTES, ...AI_EVAL_ROUTES];

// 프로젝트 배정 콘솔 하위 2단계 그룹의 라우트 매핑 (콘솔 본체 + 고급 항목)
const PROJECT_CONSOLE_ROUTES = ['ManagingProjectConsole', 'ManagingCampaignConnectRule', 'ManagingProjectSchema'];

export default {
    name: 'app-sidebar',
    data() {
        return {
            parentLinkCollapseState: {
                assessment: false,
                projectConsole: false,
                user: false,
                payment: false,
                mail: false,
                aiAssessment: false,
                aiSupplement: false,
                aiEval: false,
                attachments: false
            }
        };
    },
    computed: {
        ...mapState(['is_admin']),
        user_name() {
            return this.$store.getters.getUserName;
        },
        company_name() {
            return this.$store.getters.getCompanyName;
        },
        parentLinkActive() {
            const _curremt_route_name = this.$route.name;
            return {
                assessment: ['ManagingAssessment', 'ManagingProjectCode', 'ManagingProjectGroup', 'ManagingProjectConsole', 'ManagingCampaignConnectRule', 'ManagingProjectSchema', 'ManagingVendorCode', 'CampaignRemap'].includes(_curremt_route_name),
                projectConsole: PROJECT_CONSOLE_ROUTES.includes(_curremt_route_name),
                user: ['ManagingClient', 'ManagingParticipationCompany', 'ManagingUser', 'CompanyDetail'].includes(_curremt_route_name),
                aiAssessment: AI_ALL_ROUTES.includes(_curremt_route_name),
                aiSupplement: AI_SUPPLEMENT_ROUTES.includes(_curremt_route_name),
                aiEval: AI_EVAL_ROUTES.includes(_curremt_route_name),
                downloadCenter: ['DownloadCenter'].includes(_curremt_route_name),
                mail: ['MailDashboard', 'MailEditorNew', 'MailEditorEdit', 'MailSnippet', 'MailSimulation', 'ProjectBrandManagement'].includes(_curremt_route_name),
                attachments: ['CopyAttachments', 'DocumentFacts', 'DocumentFactBatches'].includes(_curremt_route_name)
            };
        }
    },
    watch: {
        '$route.name': {
            immediate: true,
            handler(_name) {
                if (_name) {
                    this.parentLinkCollapseState = {
                        assessment: ['ManagingAssessment', 'ManagingProjectCode', 'ManagingProjectGroup', 'ManagingProjectConsole', 'ManagingCampaignConnectRule', 'ManagingProjectSchema', 'ManagingVendorCode', 'CampaignRemap'].includes(_name),
                        projectConsole: PROJECT_CONSOLE_ROUTES.includes(_name),
                        user: ['ManagingClient', 'ManagingParticipationCompany', 'ManagingUser', 'CompanyDetail'].includes(_name),
                        aiAssessment: AI_ALL_ROUTES.includes(_name),
                        aiSupplement: AI_SUPPLEMENT_ROUTES.includes(_name),
                        aiEval: AI_EVAL_ROUTES.includes(_name),
                        downloadCenter: ['DownloadCenter'].includes(_name),
                        mail: ['MailDashboard', 'MailEditorNew', 'MailEditorEdit', 'MailSnippet', 'MailSimulation', 'ProjectBrandManagement'].includes(_name),
                        attachments: ['CopyAttachments', 'DocumentFacts', 'DocumentFactBatches'].includes(_name)
                    };
                }
            }
        }
    }
};
</script>

<style lang="scss">
$color-title: rgba($color: #aaaaaa, $alpha: 1.0);
$color-title-active: rgba($color: #454545, $alpha: 1.0);
$color-title-sub: rgba($color: #b2b2b2, $alpha: 1.0);
$color-title-sub-active: rgba($color: #4b4b4b, $alpha: 1.0);

.admin-sidebar {
    box-shadow: 5px 0px 0.25rem rgba(0, 0, 0, 0.075);

    .admin-sidebar-links {
        padding: 0.5rem 0.3rem;

        .observability-menu-item {
            margin-top: 1.25rem;
            padding-top: 0.75rem;
            border-top: 1px solid #e2e8ef;

            > .nav-link {
                padding: 0.5rem 0.8rem;
                color: #64748b;
                font-size: 0.82rem;
                font-weight: 400;

                &:hover,
                &.router-link-exact-active {
                    color: #425f75;
                    background-color: #f5f8fb;
                }
            }
        }

        .nav-parent-group {
            .nav-parent {
                position: relative;
                padding: 0.5rem 1.5rem;
                width: 100%;
                color: $color-title-sub;
                font-size: 1.1rem;
                font-weight: 600;


                &::before {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: 0;
                    width: 10px;
                    height: 10px;
                    transform: translateY(-50%);
                    display: block;
                    border: 3px solid #b56e6e;
                    border-radius: 100%;
                }

                &.active {
                    color: $color-title-active;
                }
            }

            &:hover .nav-parent {
                color: $color-title-active;
            }
        }

        .nav-child-link .nav-link {
            color: $color-title-sub;
        }

        .nav-child-group {
            padding-top: 0.5rem;
            margin-left: 4px;


            .nav-child-link {
                .nav-link {
                    position: relative;
                    border-left: 3px solid rgba($color: #eaeaea, $alpha: 1.0);
                    font-size: 0.95rem;
                    font-weight: 400;

                    &:hover,
                    &.router-link-active,
                    &.router-link-exact-active {
                        position: relative;
                        border-left: 3px solid #b56e6e;
                        font-weight: 500;
                        color: $color-title-sub-active;
                    }
                }
            }
        }

        // AI 기능 관리 하위 2단계 그룹 (보완 검토 / 평가)
        .nav-sub-group {
            list-style: none;

            // b-nav-item 이 감싸는 기본 링크 패딩 제거 (span 이 자체 패딩을 가짐)
            > .nav-link {
                padding: 0;
            }

            .nav-sub-parent {
                position: relative;
                display: block;
                padding: 0.4rem 1.75rem 0.4rem 0.75rem;
                color: darken($color-title-sub, 5%);
                font-size: 0.95rem;
                font-weight: 500;
                cursor: pointer;
                user-select: none;
                transition: color 0.15s ease;

                // 펼침/접힘 caret
                &::after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    right: 0.9rem;
                    width: 6px;
                    height: 6px;
                    border-right: 2px solid currentColor;
                    border-bottom: 2px solid currentColor;
                    transform: translateY(-70%) rotate(-45deg);
                    transition: transform 0.15s ease;
                    opacity: 0.55;
                }

                &.expanded::after {
                    transform: translateY(-30%) rotate(45deg);
                }

                &:hover,
                &.active {
                    color: $color-title-sub-active;
                }
            }

            .nav-subchild-group {
                margin-left: 0.85rem;
            }
        }

        // 프로젝트 배정 콘솔 — 링크이면서 (고급) 하위 항목을 펼치는 부모
        .nav-console-parent {
            > .nav-link {
                position: relative;

                // 하위(고급) 항목 존재를 알리는 caret
                &::after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    right: 0.9rem;
                    width: 6px;
                    height: 6px;
                    border-right: 2px solid currentColor;
                    border-bottom: 2px solid currentColor;
                    transform: translateY(-70%) rotate(-45deg);
                    transition: transform 0.15s ease;
                    opacity: 0.5;
                }
            }

            &.children-expanded > .nav-link::after {
                transform: translateY(-30%) rotate(45deg);
            }
        }
    }
}
</style>
